import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "./firebase";

function safeName(name = "image") {
  return name.replace(/[^a-zA-Z0-9._-]/g, "_");
}

export async function uploadProductImage(file) {
  if (!file) throw new Error("No file selected");
  const uniqueName = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}-${safeName(file.name)}`;
  const fileRef = ref(storage, `products/${uniqueName}`);
  await uploadBytes(fileRef, file, { contentType: file.type || "application/octet-stream" });
  return getDownloadURL(fileRef);
}
